import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const SignUpEmailInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn, clickFn, text, isClicked, setIsClicked, onEmailChange, isVerified } = props;
	const { t } = useLanguage();
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [message, setMessage] = useState(text);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const BorderRef = useRef();
	const inputRef = useRef();

	const isButtonDisabled = isClicked || isVerified;

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
		setDefaultPlaceholder(val);

		if (isVerified) return;

		inputRef.current.style.borderColor = theme.pointRed;
		BorderRef.current.style.borderBottom = `1px solid ${theme.pointRed}`;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.buttonStroke;
			BorderRef.current.style.borderBottom = `1px solid ${theme.line}`;
		}
	}));

	useEffect(() => {
		const borderEl = BorderRef.current;

		if (!borderEl) return;

		if (isVerified) {
			borderEl.style.borderBottom = `1px solid ${theme.line}`; // 인증완료면 항상 회색

			return;
		}

		if (isClicked) {
			borderEl.style.borderBottom = `1px solid ${theme.line}`;

			return;
		}

		// 기본 상태
		borderEl.style.borderBottom = `1px solid ${theme.line}`;
	}, [isVerified, isClicked]);

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function handleClick(e) {
		if (!isVerified) {
			inputRef.current.style.borderColor = theme.primary;
			BorderRef.current.style.borderBottom = `1px solid ${theme.primary}`;
		}
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		const next = e.target.value;
		setValue(next);
		setChanged(true);
		onEmailChange && onEmailChange(next);
    	setIsClicked(false);
	}

	function handleFocus(e) {
	}

	function handleBlur() {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;

		if (isVerified) {
		BorderRef.current.style.borderBottom = `1px solid ${theme.line}`;
		}
		else {
		BorderRef.current.style.borderBottom = `1px solid ${theme.line}`;
		}
	}

	function handleCheckClick(e) {
		e.stopPropagation();

		if (isButtonDisabled) return;
		clickFn && clickFn();
	}

	return (
		<TopLevelWrapper ref={BorderRef}>
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={type}
				placeholder={defaultPlaceholder}
				value={value}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
				<CheckButton onClick={handleCheckClick} isClicked={isClicked} disabled={isButtonDisabled}>
					{isVerified ? t('signUp.emailVerified') : (isClicked ? t('signUp.emailChecking') : t('signUp.emailCheck'))}
				</CheckButton>
		</TopLevelWrapper>
	)
});

export default SignUpEmailInput;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: flex-end;
	
	// border-width: 0 0 1px 0;
	border-bottom: 1px solid ${props => props.theme.line};

  transition: all 0.5s ease-in-out;
	// border-color: #E8E8E8;

	
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	// border: 0px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	padding: 0 0 4px 0;
	margin-top: 10px;
	// margin-top: max(12px, 0.8333333333333333vw);

	// width: 80%;
	width: calc(100% - 79px);

	outline: none;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	border: 0px;
	background-color: transparent;
	color: ${props => props.theme.text};

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? props.theme.line : props.theme.pointRed};
	}
	
  transition: all 0.5s ease-in-out;
`;

const CheckButton = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: center;
	align-items: center;

	width: 79px;
	height: 32px;

	border-radius: 8px 8px 0 0;
	background-color: ${(props) => props.disabled ? props.theme.line : (props.isClicked ? props.theme.line : props.theme.primary)};

	opacity: ${(props) => (props.disabled ? 0.7 : 1)};
	pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

	font-family: NotoSansKR-Bold;
	font-size: max(14px, 0.625vw);

	color: ${props => props.theme.subBackground};

	margin-bottom: -1px;

	@media (hover: hover) {
		&:hover {
			cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
		}
	}
`;